import React from "react";
import PropTypes from "prop-types";
import differenceInDays from "date-fns/differenceInDays";

import Banner from "../ui/banner";

import { isTrialPeriod } from "../../utility/prop-types";

import "./trial_banner.less";

export default function TrialBanner({ currentOrganization }) {
  if (!currentOrganization || !currentOrganization.trial_period) {
    return null;
  }

  const { trial_period: { expired, end_date } } = currentOrganization;

  function getText() {
    if (expired) {
      return "Your trial has expired.";
    }

    const daysLeft = differenceInDays(
      new Date(end_date), new Date()
    );
    return `Your trial expires in ${daysLeft} days.`;
  }

  return (
    <div className="TrialBanner">
      <Banner alert={expired}>
        <div className="Banner__content">
          {getText()}
          <a href="https://demyst.com/pricing/" target="_blank">View subscription plans</a>
        </div>
        <div className="Banner__links">
          <a href={`mailto:help@demystdata.com?subject=${encodeURIComponent("Free Trial Inquiry")}`}>
            Contact Us
          </a>
        </div>
      </Banner>
    </div>
  );
}

TrialBanner.propTypes = {
  currentOrganization: PropTypes.shape({
    trial_period: isTrialPeriod
  })
};
